const actions = {
    SET_AUTH_TOKEN: "SET_AUTH_TOKEN",
    SET_SESSION_ID: "SET_SESSION_ID",
    SET_IS_USER_HOST: "SET_IS_USER_HOST",
    SET_USERS_LOGGEDS: "SET_USERS_LOGGEDS",
    SET_USUARIO_ID: "SET_USUARIO_ID",
    SET_USER_NAME: "SET_USER_NAME",
    SET_USER_AVATAR: "SET_USER_AVATAR",
    SET_ROOM_ID: "SET_ROOM_ID",
    SET_IS_ROOM_HOST: "SET_IS_ROOM_HOST",
    SET_ROOM_SOCKET_ID: "SET_ROOM_SOCKET_ID",
    SET_IDENTITY: "SET_IDENTITY",
    SET_PARTICIPANTS: "SET_PARTICIPANTS",
    SET_IS_ONLY_AUDIO: "SET_IS_ONLY_AUDIO",
    SET_IS_ONLY_CAMERA: "SET_IS_ONLY_CAMERA",
    SET_MESSAGES: "SET_MESSAGES",
    SET_DIRECT_HISTORY: "SET_DIRECT_HISTORY",
    SET_CONVERSATION_ACTIVE: "SET_CONVERSATION_ACTIVE",
    SET_PARTICIPANT_SELECTED: "SET_PARTICIPANT_SELECTED",
    SET_SEND_EMAIL_TOKEN: "SET_SEND_EMAIL_TOKEN",
    SET_SEARCH_FORM: "SET_SEARCH_FORM",
    SET_IS_RECAPTCHA: "SET_IS_RECAPTCHA",
    SET_IS_SHOW_SIDEBAR: "SET_IS_SHOW_SIDEBAR",
    SET_IS_SHOW_OVERLAY: "SET_IS_SHOW_OVERLAY",
    SET_IS_TIME_STAMP: "SET_IS_TIME_STAMP",
    SET_TIME_STAMPS: "SET_TIME_STAMPS",
    SET_AUDIO_SRC: "SET_AUDIO_SRC",
    SET_VOLUME_ICON_STREAM: "SET_VOLUME_ICON_STREAM",
    SET_INITIAL_MINUTES: "SET_INITIAL_MINUTES",
    SET_INITIAL_SECONDS: "SET_INITIAL_SECONDS",
    SET_AREAS: "SET_AREAS",
    SET_TASKS: "SET_TASKS",
    SET_QUESTIONS: "SET_QUESTIONS",
    SET_SEND_QUESTIONS: "SET_SEND_QUESTIONS",
    SET_DATA_NOTES: "SET_DATA_NOTES",
    SET_ACTORS_RESULTS: "SET_ACTORS_RESULTS",
    SET_REMOVE_DATA_NOTES: "SET_REMOVE_DATA_NOTES",
    SET_SEND_DATA_NOTES: "SET_SEND_DATA_NOTES",
    SET_STATE_DATA_NOTES: "SET_STATE_DATA_NOTES",
    SET_REMOVE_STATE_DATA_NOTES: "SET_REMOVE_STATE_DATA_NOTES",
    SET_IS_ROOM_LISTENER: "SET_IS_ROOM_LISTENER",
    SET_IS_CHECK_LISTENER: "SET_IS_CHECK_LISTENER",
    SET_SUCCESS_MESSAGE: "SET_SUCCESS_MESSAGE",
    SET_ERROR_MESSAGE: "SET_ERROR_MESSAGE",
    SET_NOTIFY_MESSAGE: "SET_NOTIFY_MESSAGE",
    SET_IS_NOTIFY_MESSAGE: "SET_IS_NOTIFY_MESSAGE",
};

export const setAuthToken = (authToken) => {
    return {
        type: actions.SET_AUTH_TOKEN,
        authToken,
    };
};

export const setSessionId = (sessionId) => {
    return {
        type: actions.SET_SESSION_ID,
        sessionId,
    };
};

export const setUsersLoggeds = (usersLoggeds) => {
    return {
        type: actions.SET_USERS_LOGGEDS,
        usersLoggeds,
    };
};

export const setIsUserHost = (isUserHost) => {
    return {
        type: actions.SET_IS_USER_HOST,
        isUserHost,
    };
};

export const setUsuarioId = (usuarioId) => {
    return {
        type: actions.SET_USUARIO_ID,
        usuarioId,
    };
};

export const setUsername = (username) => {
    return {
        type: actions.SET_USER_NAME,
        username,
    };
};

export const setUserAvatar = (userAvatar) => {
    return {
        type: actions.SET_USER_AVATAR,
        userAvatar,
    };
};

export const setRoomId = (roomId) => {
    return {
        type: actions.SET_ROOM_ID,
        roomId,
    };
};

export const setIsRoomHost = (isRoomHost) => {
    return {
        type: actions.SET_IS_ROOM_HOST,
        isRoomHost,
    };
};

export const setRoomSocketId = (roomSocketId) => {
    return {
        type: actions.SET_ROOM_SOCKET_ID,
        roomSocketId,
    };
};

export const setIdentity = (identity) => {
    return {
        type: actions.SET_IDENTITY,
        identity,
    };
};

export const setParticipants = (participants) => {
    return {
        type: actions.SET_PARTICIPANTS,
        participants,
    };
};

export const setIsOnlyAudio = (isOnlyAudio) => {
    return {
        type: actions.SET_IS_ONLY_AUDIO,
        isOnlyAudio,
    };
};

export const setIsOnlyCamera = (isOnlyCamera) => {
    return {
        type: actions.SET_IS_ONLY_CAMERA,
        isOnlyCamera,
    };
};

export const setMessages = (messages) => {
    return {
        type: actions.SET_MESSAGES,
        messages,
    };
};

export const setDirectHistory = (directHistory) => {
    return {
        type: actions.SET_DIRECT_HISTORY,
        directHistory,
    };
};

export const setConversationActive = (conversationActive) => {
    return {
        type: actions.SET_CONVERSATION_ACTIVE,
        conversationActive,
    };
};

export const setParticipantSelected = (participantSelected) => {
    return {
        type: actions.SET_PARTICIPANT_SELECTED,
        participantSelected,
    };
};

export const setSendEmailToken = (sendEmailToken) => {
    return {
        type: actions.SET_SEND_EMAIL_TOKEN,
        sendEmailToken,
    };
};

export const setSearchForm = (searchForm) => {
    return {
        type: actions.SET_SEARCH_FORM,
        searchForm,
    };
};

export const setIsShowSidebar = (showSidebar) => {
    return {
        type: actions.SET_IS_SHOW_SIDEBAR,
        showSidebar,
    };
};

export const setIsShowOverlay = (isShowOverlay) => {
    return {
        type: actions.SET_IS_SHOW_OVERLAY,
        isShowOverlay,
    };
};

export const setIsTimeStamp = (isTimeStamp) => {
    return {
        type: actions.SET_IS_TIME_STAMP,
        isTimeStamp
    };
};

export const setTimeStamps = (timeStamps) => {
    return {
        type: actions.SET_TIME_STAMPS,
        timeStamps
    };
};

export const setInitialMinutes = (initialMinutes) => {
    return {
        type: actions.SET_INITIAL_MINUTES,
        initialMinutes
    };
};

export const setInitialSeconds = (initialSeconds) => {
    return {
        type: actions.SET_INITIAL_SECONDS,
        initialSeconds
    };
};

export const setAudioSrc = (audioSrc) => {
    return {
        type: actions.SET_AUDIO_SRC,
        audioSrc,
    };
};

export const setVolumeIconStream = (volumeIconStream) => {
    return {
        type: actions.SET_VOLUME_ICON_STREAM,
        volumeIconStream,
    };
};

export const setDataNotes = (dataNotes) => {
    return {
        type: actions.SET_DATA_NOTES,
        dataNotes,
    };
};

export const setActorsResults = (actorsResults) => {
    return {
        type: actions.SET_ACTORS_RESULTS,
        actorsResults,
    };
};

export const setRemoveDataNotes = (id) => {
    return {
        type: actions.SET_REMOVE_DATA_NOTES,
        id
    };
};

export const setTasks = (tasks) => {
    return {
        type: actions.SET_TASKS,
        tasks,
    };
};

export const setAreas = (areas) => {
    return {
        type: actions.SET_AREAS,
        areas,
    };
};

export const setQuestions = (questions) => {
    return {
        type: actions.SET_QUESTIONS,
        questions,
    };
};

export const setSendQuestions = (sendQuestions) => {
    return {
        type: actions.SET_SEND_QUESTIONS,
        sendQuestions,
    };
};

export const setSendDataNotes = (sendDataNotes) => {
    return {
        type: actions.SET_SEND_DATA_NOTES,
        sendDataNotes,
    };
};

export const setStateDataNotes = (stateDataNotes) => {
    return {
        type: actions.SET_STATE_DATA_NOTES,
        stateDataNotes,
    };
};

export const setRemoveStateDataNotes = (id) => {
    return {
        type: actions.SET_REMOVE_STATE_DATA_NOTES,
        id
    };
};

export const setIsRecaptcha = (isRecaptcha) => {
    return {
        type: actions.SET_IS_RECAPTCHA,
        isRecaptcha
    }
};

export const setIsRoomListener = (isRoomListener) => {
    return {
        type: actions.SET_IS_ROOM_LISTENER,
        isRoomListener,
    };
};

export const setIsCheckListener = (isCheckListener) => {
    return {
        type: actions.SET_IS_CHECK_LISTENER,
        isCheckListener,
    };
};

export const setSuccessMessage = (successMessage) => {
    return {
        type: actions.SET_SUCCESS_MESSAGE,
        successMessage,
    };
};

export const setErrorMessage = (errorMessage) => {
    return {
        type: actions.SET_ERROR_MESSAGE,
        errorMessage,
    };
};

export const setNotifyMessage = (notifyMessage) => {
    return {
        type: actions.SET_NOTIFY_MESSAGE,
        notifyMessage,
    };
};

export const setIsNotifyMessage = (isNotifyMessage) => {
    return {
        type: actions.SET_IS_NOTIFY_MESSAGE,
        isNotifyMessage,
    };
};

export default actions;
